import { CalendarRequest } from 'gql/autogen/CalendarRequest';
import { RootState } from 'store/store.types';
import { mapActivityForDetail } from 'gql/service/graph/activityService';
import { ActivityGqlOperation, CalendarRequestProps, GqlLogTags } from 'store/api/api.types';
import { InternalContext } from 'gql/autogen/InternalContext';
import { getDateInYmdFormat, getDateWithoutTime, getTodayDate } from 'core-framework/util/datetime/date';
import { addDays, subDays, differenceInDays } from 'date-fns';
import { getGeoLogTags } from 'core/service/measurements/measurementUtils';

const validateProps = (props: CalendarRequestProps): boolean => {
    const startDate = props.startDate;
    const endDate = props.endDate;
    if (!startDate || !endDate) {
        return false;
    }
    const isStartDateValid = differenceInDays(startDate, getTodayDate()) >= 0;
    const isEndDateValid = differenceInDays(endDate, startDate) >= 0;
    return isStartDateValid && isEndDateValid;
};

const build = (state: RootState, props: CalendarRequestProps, context: InternalContext): CalendarRequest => {
    const { activityToken } = props;
    const todayDate = getDateWithoutTime(getTodayDate());
    let latestPossibleDate = addDays(todayDate, 30);
    const dateDiff = differenceInDays(latestPossibleDate, todayDate);

    // Hack to fix daylight saving issues, reduce 1 day
    if (dateDiff > 30) {
        latestPossibleDate = subDays(latestPossibleDate, 1);
    }

    const isPropsValid = validateProps(props);

    const startDate = isPropsValid && props.startDate ? props.startDate : getDateInYmdFormat(todayDate);
    const endDate = isPropsValid && props.endDate ? props.endDate : getDateInYmdFormat(latestPossibleDate);

    return {
        context,
        calendarRequest: {
            activityToken,
            startDate: { value: startDate },
            endDate: { value: endDate },
        },
    };
};

export const buildLogTags = (state: RootState, variables: Record<string, unknown>): GqlLogTags => {
    const request = (variables as unknown as { CalendarRequest: CalendarRequest }).CalendarRequest.calendarRequest;
    const activity = mapActivityForDetail(state.details);
    const geoTags = getGeoLogTags(state.bootstrap.config);
    return {
        ...geoTags,
        operation: ActivityGqlOperation.calendar,
        supplierId: String(activity.masterSupplierId || 0),
        activityToken: request.activityToken,
        startDate: request.startDate?.value || '',
        endDate: request.endDate?.value || '',
    };
};

export default build;
